<template>
    <!--弹窗-->
    <el-dialog width="400px" :title="title" :visible.sync="visible" :before-close="handleClose">
        <el-form ref="formData" :model="formData" label-width="140px" :rules="rules">
            <el-form-item label="关键词数量上限：" prop="keyword_limit">
                <el-input v-model="formData.keyword_limit" onkeyup="value=value.replace(/[^0-9\.]/g,'')" style="width: 200px;margin-right:20px;" placeholder="请输入关键词数量上限"></el-input>
            </el-form-item>
        </el-form>
        <el-row style="margin-top:17px; ">
            <el-button
                style="float:right;margin-left:6px;"
                size="mini"
                type="danger"
                plain
                @click="handleClose"
            >取 消</el-button>
            <el-button style="float:right" size="mini" type="primary" @click="submitForm('formData')" :loading="loading">确定</el-button>
        </el-row>
    </el-dialog>
</template>
<script>
import * as api from "@/api/user/user";
export default {
    data() {
        return {
            loading: false,
            rules: {
                keyword_limit: [
                    {
                        required: true,
                        message: "请输入关键词数量上限",
                        trigger: "blur"
                    }
                ]
            }
        };
    },
    props: {
        formData: {
            type: Object,
            default: () => {}
        },
        visible: {
            type: Boolean,
            default: false
        },
        title: {
            type: String,
            default: ""
        }
    },
    methods: {
        // 保存信息
        submitForm(formData) {
            this.$refs[formData].validate(valid => {
                if (valid) {
                    if (this.formData.keyword_limit < 0) {
                        return this.$message({
                            type: "error",
                            message: "请输入大于0的整数"
                        });
                    }
                    this.loading = true;
                    api.set_property_admin({
                        admin_id: this.formData.id,
                        keyword_limit: Math.round(
                            Number(this.formData.keyword_limit)
                        )
                    })
                        .then(res => {
                            if (res.code === 0) {
                                this.$message({
                                    message: "设置成功",
                                    type: "success"
                                });
                                this.handleClose();
                            } else {
                                this.loading = false;
                                this.$message({
                                    type: "error",
                                    message: res.message
                                });
                            }
                        })
                        .catch(() => {
                            this.loading = false;
                            this.$message({
                                type: "error",
                                message:
                                    "网络出现问题，请刷新页面查看订单是否完成！"
                            });
                        });
                } else {
                    this.loading = false;
                    this.$message({
                        type: "error",
                        message: "请填写相应内容！"
                    });
                }
            });
        },
        // 关闭弹窗
        handleClose(isshow) {
            this.$refs["formData"].resetFields();
            this.loading = false;
            this.$emit("close-callback", isshow);
        }
    }
};
</script>
<style type="text/scss" lang="scss" scoped>
</style>
